export default __webpack_public_path__ + "static/Leaf11-f1171f775e78936d2dc44bbcb621441d.png";